export default __webpack_public_path__ + "static/media/Staff (Sales) Management.27dc8197.png";